import 'isomorphic-fetch'
import { getApiBaseUrlWithOrg, checkHttpStatus, getApiHeaders } from '../utils'
import { basicGet } from '../utils/api'
import { getErrorAction } from '../utils/actions'

export const REQUEST_QUEST_COMMENTS = 'REQUEST_QUEST_COMMENTS'
export const RECEIVE_QUEST_COMMENTS = 'RECEIVE_QUEST_COMMENTS'
export const FAILED_QUEST_COMMENTS = 'FAILED_QUEST_COMMENTS'
export const POST_QUEST_COMMENT = 'POST_QUEST_COMMENT'
export const RESOLVE_QUEST_COMMENT = 'RESOLVE_QUEST_COMMENT'
export const OPEN_QUEST_COMMENT = 'OPEN_QUEST_COMMENT'
export const REQUEST_QUEST_ACTIVITY_COMMENTS = 'REQUEST_QUEST_ACTIVITY_COMMENTS'
export const RECEIVE_QUEST_ACTIVITY_COMMENTS = 'RECEIVE_QUEST_ACTIVITY_COMMENTS'
export const FAILED_QUEST_ACTIVITY_COMMENTS = 'FAILED_QUEST_ACTIVITY_COMMENTS'
export const EDIT_DRAFT_QUEST_COMMENT_REQUEST =
  'EDIT_DRAFT_QUEST_COMMENT_REQUEST'
export const EDIT_DRAFT_COMMENT_SUCCESS = 'EDIT_DRAFT_COMMENT_SUCCESS'
export const FETCH_USER_QUEST_COMMENTS_REQUEST =
  'FETCH_USER_QUEST_COMMENTS_REQUEST'
export const FETCH_USER_QUEST_COMMENTS_SUCCESS =
  'FETCH_USER_QUEST_COMMENTS_SUCCESS'
export const FETCH_USER_QUEST_COMMENTS_FAILURE =
  'FETCH_USER_QUEST_COMMENTS_FAILURE'
export const FETCH_USER_ACTIVITY_COMMENTS_REQUEST =
  'FETCH_USER_ACTIVITY_COMMENTS_REQUEST'
export const FETCH_USER_ACTIVITY_COMMENTS_SUCCESS =
  'FETCH_USER_ACTIVITY_COMMENTS_SUCCESS'
export const FETCH_USER_ACTIVITY_COMMENTS_FAILURE =
  'FETCH_USER_ACTIVITY_COMMENTS_FAILURE'
export const POST_ACTIVITY_COMMENT = 'POST_ACTIVITY_COMMENT'
export const POST_USER_QUEST_COMMENT = 'POST_USER_QUEST_COMMENT'
export const POST_USER_ACTIVITY_COMMENT = 'POST_USER_ACTIVITY_COMMENT'
export const PUBLISH_DRAFT_QUEST_COMMENT = 'PUBLISH_DRAFT_QUEST_COMMENT'
export const PUBLISH_DRAFT_ACTIVITY_COMMENT = 'PUBLISH_DRAFT_ACTIVITY_COMMENT'
export const EDIT_DRAFT_QUEST_COMMENT = 'EDIT_DRAFT_QUEST_COMMENT'
export const EDIT_DRAFT_ACTIVITY_COMMENT = 'EDIT_DRAFT_ACTIVITY_COMMENT'
export const EDIT_QUEST_COMMENT = 'EDIT_QUEST_COMMENT'
export const EDIT_ACTIVITY_COMMENT = 'EDIT_ACTIVITY_COMMENT'
export const DELETE_QUEST_COMMENT = 'DELETE_QUEST_COMMENT'
export const DELETE_ACTIVITY_COMMENT = 'DELETE_ACTIVITY_COMMENT'
export const DELETE_DRAFT_QUEST_COMMENT = 'DELETE_DRAFT_QUEST_COMMENT'
export const DELETE_DRAFT_ACTIVITY_COMMENT = 'DELETE_DRAFT_ACTIVITY_COMMENT'
export const IS_EDITING_COMMENT = 'IS_EDITING_COMMENT'
export const IS_NOT_EDITING_COMMENT = 'IS_NOT_EDITING_COMMENT'

export function isEditingComment() {
  return {
    type: IS_EDITING_COMMENT
  }
}

export function isNotEditingComment() {
  return {
    type: IS_NOT_EDITING_COMMENT
  }
}

export function deleteCommentAction(resourceType, commentId, commentType) {
  let type =
    commentType === 'draft'
      ? resourceType === 'Quest'
        ? DELETE_DRAFT_QUEST_COMMENT
        : DELETE_DRAFT_ACTIVITY_COMMENT
      : resourceType === 'Quest'
      ? DELETE_QUEST_COMMENT
      : DELETE_ACTIVITY_COMMENT

  return {
    type: type,
    commentId: commentId
  }
}

export function editCommentAction(
  resourceType,
  commentId,
  comment,
  publish,
  commentType
) {
  let type =
    commentType === 'draft'
      ? publish
        ? resourceType === 'Quest'
          ? PUBLISH_DRAFT_QUEST_COMMENT
          : PUBLISH_DRAFT_ACTIVITY_COMMENT
        : resourceType === 'Quest'
        ? EDIT_DRAFT_QUEST_COMMENT
        : EDIT_DRAFT_ACTIVITY_COMMENT
      : resourceType === 'Quest'
      ? EDIT_QUEST_COMMENT
      : EDIT_ACTIVITY_COMMENT

  return {
    type: type,
    comment: comment,
    commentId: commentId
  }
}

export function postCommentAction(resourceType, comment, publish) {
  let type = publish
    ? resourceType === 'Quest'
      ? POST_QUEST_COMMENT
      : POST_ACTIVITY_COMMENT
    : resourceType === 'Quest'
    ? POST_USER_QUEST_COMMENT
    : POST_USER_ACTIVITY_COMMENT

  return {
    type: type,
    comment: comment
  }
}

export function resolveCommentAction(resourceType, commentId) {
  return {
    type: RESOLVE_QUEST_COMMENT,
    resourceType: resourceType,
    commentId: commentId
  }
}

export function openCommentAction(resourceType, commentId) {
  return {
    type: OPEN_QUEST_COMMENT,
    resourceType: resourceType,
    commentId: commentId
  }
}

export function requestQuestComments() {
  return {
    type: REQUEST_QUEST_COMMENTS
  }
}

export function receiveQuestComments(response) {
  return {
    type: RECEIVE_QUEST_COMMENTS,
    comments: response.comments
  }
}

export function failedQuestComments(error) {
  return getErrorAction(FAILED_QUEST_COMMENTS, error)
}

export function requestQuestActivityComments() {
  return {
    type: REQUEST_QUEST_ACTIVITY_COMMENTS
  }
}

export function receiveQuestActivityComments(response) {
  return {
    type: RECEIVE_QUEST_ACTIVITY_COMMENTS,
    comments: response.comments
  }
}

export function failedQuestActivityComments(error) {
  return getErrorAction(FAILED_QUEST_ACTIVITY_COMMENTS, error)
}

export function fetchUserQuestCommentsRequest() {
  return {
    type: FETCH_USER_QUEST_COMMENTS_REQUEST
  }
}

export function fetchUserQuestCommentsSuccess(response) {
  return {
    type: FETCH_USER_QUEST_COMMENTS_SUCCESS,
    payload: {
      comments: response.comments
    }
  }
}

export function fetchUserQuestCommentsFailure(error) {
  return getErrorAction(FETCH_USER_QUEST_COMMENTS_FAILURE, error)
}

export function fetchUserActivityCommentsRequest() {
  return {
    type: FETCH_USER_ACTIVITY_COMMENTS_REQUEST
  }
}

export function fetchUserActivityCommentsSuccess(response) {
  return {
    type: FETCH_USER_ACTIVITY_COMMENTS_SUCCESS,
    payload: {
      comments: response.comments
    }
  }
}

export function fetchUserActivityCommentsFailure(error) {
  return getErrorAction(FETCH_USER_ACTIVITY_COMMENTS_FAILURE, error)
}

export function fetchQuestComments(id, state) {
  return dispatch => {
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/comments/Quest/${id}`
    return basicGet(
      state,
      dispatch,
      url,
      requestQuestComments,
      receiveQuestComments,
      failedQuestComments
    )
  }
}

export function fetchQuestActivityComments(id, state) {
  return dispatch => {
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/comments/Quest/${id}/a/activities`
    return basicGet(
      state,
      dispatch,
      url,
      requestQuestActivityComments,
      receiveQuestActivityComments,
      failedQuestActivityComments
    )
  }
}

export function fetchUserQuestComments(id, state) {
  return dispatch => {
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/user/comments/Quest/${id}?q[state_in][]=0`
    return basicGet(
      state,
      dispatch,
      url,
      fetchUserQuestCommentsRequest,
      fetchUserQuestCommentsSuccess,
      fetchUserQuestCommentsFailure
    )
  }
}

export function fetchUserActivityComments(id, state) {
  return dispatch => {
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/user/comments/Quest/${id}/a/activities?q[state_in][]=0`
    return basicGet(
      state,
      dispatch,
      url,
      fetchUserActivityCommentsRequest,
      fetchUserActivityCommentsSuccess,
      fetchUserActivityCommentsFailure
    )
  }
}

export function openComment(
  resourceId: number,
  resourceType: string,
  commentId: number
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/comments/${resourceType}/${resourceId}/${commentId}/open`
    try {
      checkHttpStatus(
        await fetch(url, {
          method: 'PATCH',
          headers: getApiHeaders(state)
        })
      )
      dispatch(openCommentAction(resourceType, commentId))
    } catch (error) {
      console.log(error)
    }
  }
}

export function deleteComment(
  resourceId: number,
  resourceType: string,
  commentId: number,
  commentType
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/comments/${resourceType}/${resourceId}/${commentId}`
    try {
      checkHttpStatus(
        await fetch(url, {
          method: 'DELETE',
          headers: getApiHeaders(state)
        })
      )
      dispatch(deleteCommentAction(resourceType, commentId, commentType))
    } catch (error) {
      console.log(error)
    }
  }
}

export function editComment(
  resourceId: number,
  resourceType: string,
  commentId: number,
  body: string,
  label: string,
  commentType,
  publish
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/comments/${resourceType}/${resourceId}/${commentId}`
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'PUT',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            comment: {
              body: body,
              label: label,
              publish: publish
            }
          })
        })
      )
      const json = await response.json()
      dispatch(
        editCommentAction(resourceType, commentId, json, publish, commentType)
      )
    } catch (error) {
      console.log(error)
    }
  }
}

export function resolveComment(
  resourceId: number,
  resourceType: string,
  commentId: number
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/comments/${resourceType}/${resourceId}/${commentId}/resolve`
    try {
      checkHttpStatus(
        await fetch(url, {
          method: 'PATCH',
          headers: getApiHeaders(state)
        })
      )
      dispatch(resolveCommentAction(resourceType, commentId))
    } catch (error) {
      console.log(error)
    }
  }
}

export function postComment(
  resourceId: number,
  section: string,
  label: string,
  body: string,
  publish
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const resourceType = section === 'activities' ? 'Activity' : 'Quest'
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/comments/${resourceType}/${resourceId}`
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'POST',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            comment: {
              label: label,
              body: body,
              resource_type: resourceType,
              resource_id: resourceId,
              section: section,
              publish: publish
            }
          })
        })
      )
      const json = await response.json()
      dispatch(postCommentAction(resourceType, json, publish))
    } catch (error) {
      console.log(error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/comments.js